import SOCBadge from 'assets/images/soc_2.svg';

const Footer = () => (
  <div className="flex items-center w-full global-footer mt-auto border-t border-navy-200 h-[84px] px-8">
    <div className="flex-1 flex items-center gap-6">
      <a
        href="https://marketviewedu.com/terms-conditions/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-navy-800 font-semibold hover:underline"
      >
        Terms &amp; Conditions
      </a>
      <a
        href="https://marketviewedu.com/marketview-platform-privacy-policy/"
        target="_blank"
        rel="noopener noreferrer"
        className="text-sm text-navy-800 font-semibold hover:underline"
      >
        Privacy Policy
      </a>
    </div>

    <a
      href="https://www.aicpa.org/interestareas/frc/assuranceadvisoryservices/aicpasoc2report.html"
      target="_blank"
      rel="noopener noreferrer"
      className="flex items-center"
    >
      <img
        src={SOCBadge}
        alt="MARKETview is proud to be SOC 2 Type II Certified"
        className="w-32"
      />
    </a>
  </div>
);

export default Footer;
